@if (this.numpadService.state$ | async; as state) {
    <div class="stake-field-container" [ngClass]="{ disabled: disabled, selected: selected }" (click)="!disabled && onClick()">
        <vn-icon
            name="theme-error-i"
            class="numpad-theme-error stake-field"
            [class.icon-allignment]="isEpcotEnabled"
            [size]="isEpcotEnabled ? '16' : '12'" />
        @if (adornmentStart) {
            <span class="stake-field-adornment stake-field-adornment--start">{{ adornmentStart }}</span>
        }
        <div class="stake-field-scroll-container">
            @if (useStakeFieldCursor) {
                <input
                    #inputRef
                    class="stake-field-input stake-field-value"
                    inputmode="none"
                    autocomplete="off"
                    [placeholder]="emptyCharacter"
                    [attr.disabled]="disabled ? '' : null"
                    [style]="'width:' + (getStake(state).length + 1) + 'ch'"
                    [ngClass]="{ 'empty-stake': state.stake.isEmpty }"
                    (focus)="onFocus()"
                    (blur)="onBlur()"
                    (keydown)="(false)" />
            } @else {
                <span class="stake-field-value" [ngClass]="{ 'empty-stake': state.stake.isEmpty }">
                    {{ getStake(state) }}
                </span>
            }
        </div>
    </div>
}
